import { escapeKey, splitKeypath as splitKeypathI, unescapeKey } from '../../shared/keypaths';

export function joinKeys () {
	var keys = [], len = arguments.length;
	while ( len-- ) keys[ len ] = arguments[ len ];

	return keys.map( escapeKey ).join( '.' );
}

export function splitKeypath ( keypath ) {
	return splitKeypathI( keypath ).map( unescapeKey );
}

//# sourceMappingURL=/home/travis/build/ractivejs/ractive/.gobble-build/01-transpile/.cache/Ractive/static/keypaths.js.map
